import React from "react";
import PropTypes from "prop-types";

import styles from "./styles.css";
import Modal from "../../shared/modal";
import CloseButton from "../../shared/icon-cross";
import ArrowIcon from "../../shared/arrow";
import Button from "../../shared/button";
import Accordion from "../../shared/accordion";
import { NUMBER } from "../../../constants/app-constants";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { useHistory } from "react-router";
import { getTestDriveCheckoutURL } from "../../../utils/helpers/get-detail-page-url";
import { testDriveRoutes } from "../../../constants/au.desktop/test-drive-routes";
import { LOGIN_TYPE } from "../../../constants/checkout-constants";

const accordianData = [
    {
        key: "faqOne",
        heading: "How does the test drive work?",
        answer: "To test drive a car at CARS24 you need to;",
        data: [
            "1. Pay a refundable $500 deposit to reserve your car. This deposit will be refunded after your test drive if you do not purchase the car, or will reduce the amount payable for the car should you choose to buy it.",
            "2. Organise a test drive date and time. One of our customer executives will call you to arrange this.",
            "3. Pick-up the car from the CARS24 facility in Brisbane",
            "4. Test drive the car for up to 30 minutes",
            "5. Return the car",
            "6. Purchase or initate a deposit refund."
        ]
    },
    {
        key: "faqTwo",
        heading: "How long is the test drive?",
        answer: "The test drive will last for up to 30 minutes."
    },
    {
        key: "faqThree",
        heading: "Why do I need to pay?",
        answer: "The $500 refundable deposit is required to secure your test drive slot, and reserve the car only for you for a period of 3 days. This gives you exclusive rights to drive and buy the car during this time. "
    },
    {
        key: "faqFour",
        heading: "How do I get my deposit back?",
        answer: "If you don’t like the car after test driving, you can initate a refund through the My booking screen in your CARS24 account."
    },
    {
        key: "faqFive",
        heading: "Where is the test drive location?",
        answer: "You will pick-up the car for your test drive from one of our 3 test drive locations.",
        data: [
            "",
            "40 Steel Place",
            "Morningside",
            "QLD",
            "4170",
            "",
            "19 Link court",
            "Brooklyn",
            "VIC",
            "3012",
            "",
            "2 Helles Ave",
            "Moorebank",
            "NSW",
            "2170"
        ]
    }
];

const TestDriveFaqModal = ({  onClose, setLoginTypeConnect, content}) => {

    const history = useHistory();

    const onClickTestDrive = async () => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CARS24_DETAIL_PAGE, {
            eventAction: "test_driva_initial_page_cta_selected",
            eventLabel: "book_test_drive"
        });
        const {relativeURL} = getTestDriveCheckoutURL(content, testDriveRoutes.basicDetails.route);
        history.push(relativeURL);
        setLoginTypeConnect(LOGIN_TYPE.TEST_DRIVE);
    };

    return (
        <Modal isOpen={true} >
            <div styleName={"styles.wrapper"}>
                <div styleName={"styles.headerWrap"}>
                    <h3 styleName={"styles.heading"}>Test drive FAQs</h3>
                    <CloseButton type="grey" onClickHandler={onClose} />
                </div>
                <div styleName={"styles.contentWrap"}>

                    {accordianData.map(({key, heading, answer, data}, index) => (
                        <Accordion key={key} toggleAll={true} totalItems={accordianData.length} collapseAccordion={true}>
                            {({ onClick, currentVisibleStates }) => (
                                <div styleName={"styles.border"} onClick={() => {
                                    trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.HOW_IT_WORKS, {
                                        eventLabel: currentVisibleStates[index] ? `faq_open_question_${index + 1}` : `faq_close_question_${index + 1}`
                                    });
                                    onClick({index});
                                }}>
                                    <Accordion.Content>
                                        <Accordion.Heading>
                                            <h4 styleName={"styles.subheading"}>{heading}
                                                <span><ArrowIcon black="BlackArrow" rotateBy={currentVisibleStates[index] ? 0 : NUMBER.ONE_HUNDRED_EIGHTY}/></span></h4>
                                        </Accordion.Heading>
                                        <Accordion.Body>
                                            {!currentVisibleStates[index] &&
                                    (

                                        <div>
                                            <h5 styleName={"styles.heading-text"}>{answer}
                                                {data && data.length && (
                                                    <ul>
                                                        {data.map((item =>
                                                            item ? <li key={item}>{item}</li> : <br />))
                                                        }
                                                    </ul>
                                                )}
                                            </h5>
                                        </div>
                                    )
                                            }
                                        </Accordion.Body>
                                    </Accordion.Content>
                                </div>

                            )}
                        </Accordion>)
                    )}
                    {/* <div styleName={"styles.border"}>
                        <h4 styleName={"styles.subheading"}>Where is the test drive location? <span><ArrowIcon black="BlackArrow" /></span></h4>
                        <h5 styleName={"styles.heading-text"}>You will pick-up the car for your test drive from our Brisbane facility.
                            <ul styleName={"styles.liststyle"}>
                                <p>40 Steel Place</p>
                                <p>Morningside</p>
                                <p> QLD</p>
                                <p> 4170</p>
                            </ul>
                        </h5>
                    </div> */}
                </div>
                <div styleName={"styles.buttonWrapper"}>
                    <Button text="Book a test drive" onClick={onClickTestDrive} />
                </div>
            </div>
        </Modal>

    );
};

TestDriveFaqModal.propTypes = {
    onClose: PropTypes.func,
    onClickTestDrive: PropTypes.func,
    setLoginTypeConnect: PropTypes.func,
    content: PropTypes.object
};

export default TestDriveFaqModal;
